import { z } from 'zod'
import { allowedMime, MAX_FILE_BYTES } from './constants'

export const fileSchema = z
  .instanceof(File, { message: 'Debes adjuntar un archivo' })
  .refine((file) => file.size > 0, { message: 'El archivo está vacío' })
  .refine((file) => file.size <= MAX_FILE_BYTES, {
    message: 'El archivo no debe superar 10 MB',
  })
  .refine(
    (file) => {
      const okMime = file.type && allowedMime.includes(file.type)
      const okExt = /\.(pdf|jpe?g|png)$/i.test(file.name)
      return okMime || okExt
    },
    { message: 'Solo se permiten archivos PDF, JPG, JPEG o PNG' }
  )
